import React from "react";

const S2SCampaignsListView = React.lazy(
  () => import("./S2SCampaignsList.view")
);

const S2SCampaignsListLoadable = () => <S2SCampaignsListView />;
export default () => <S2SCampaignsListLoadable />;
